<template>
  <v-card width="52" flat>
    <v-select v-model="computedValue" dense :items="items" hide-details @change="$emit('change')">
      <template #selection="{ item }">
        <v-icon>{{ item.text }}</v-icon>
      </template>
      <template #item="{ item }">
        <v-icon>{{ item.text }}</v-icon>
      </template>
    </v-select>
  </v-card>
</template>

<script>
export default {
  name: "InputIcon",
  components: {},
  mixins: [],
  props: {
    value: { type: String, required: false, default: "default" },
  },
  data() {
    return {
      items: [
        { text: "mdi-lightning-bolt", value: "default" },
        { text: "$batteryOutline", value: "storage" },
        { text: "$thermal", value: "thermal" },
        { text: "$geothermal", value: "geothermal" },
        { text: "$pv", value: "solar" },
        { text: "$hydro", value: "hydro" },
        { text: "mdi-wind-turbine", value: "wind" },
        { text: "mdi-finance", value: "market" },
      ],
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style></style>
